import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import NavigationSetter from './components/NavigationSetter';
import './assets/css/override.css';
import './assets/css/Reboot.css';
import './assets/css/Reset.css';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './assets/css/Global.css';
import './assets/css/override.css';
import { Provider } from 'react-redux';
import store from './redux/store';
import './i18n';
import './lib/firebase';
import { GoogleOAuthProvider } from '@react-oauth/google';

// Apply theme class immediately to prevent flash of wrong theme
(function initTheme() {
  const stored = localStorage.getItem('theme');
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const isDark = stored === 'dark' || (stored !== 'light' && prefersDark);
  if (isDark) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
})();

const container = document.querySelector("#root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <NavigationSetter>
        <GoogleOAuthProvider clientId="27188786303-dtoohfdf0ai31fin4p050mnaqa3e9fnf.apps.googleusercontent.com">
          <App />
        </GoogleOAuthProvider>
      </NavigationSetter>
    </BrowserRouter>
  </Provider>
);